// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import type { FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { acquireToken } from "../utils/auth/AuthActions";

const baseURL = process.env.REACT_APP_BACKEND_API_BASE_URL;

const baseQuery = fetchBaseQuery({
  baseUrl: baseURL,
  prepareHeaders: async (headers) => {
    const token = await acquireToken();
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    if (
      !headers.has("Content-Type") ||
      headers.get("Content-Type")?.includes("text/plain")
    ) {
      headers.set("Content-Type", "application/json");
    }
    return headers;
  },
});

const staggeredBaseQueryWithBailOut = retry(
  async (args: string | FetchArgs, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result.error?.status) {
      // Bail out of retries if it fails
      const { status } = result.error;
      const failedStatuses: FetchBaseQueryError["status"][] = [
        401, 403, 404, 500,
      ];
      if (failedStatuses.includes(status)) {
        retry.fail(result.error);
      }
    }

    return result;
  },
  {
    maxRetries: 5,
  }
);

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery: staggeredBaseQueryWithBailOut,
  endpoints: () => ({}),
});
